import { useEffect, useState } from 'react';

/*
 * Open AI Training Inbox cards per operator and channel, shared by the inbox tabs and the
 * main menu: both show the same number, and the menu badge follows along as agents work
 * through cards on the tab. Keyed by operator because a franchise's AI Suite page can be
 * looking at a different licensee than the menu is.
 */
const counts = {};
const listeners = new Set();

const keyFor = (topId, channel) => `${topId}:${channel}`;

export function setTrainingInboxCount(topId, channel, count) {
  if (!topId || count == null) return;
  const key = keyFor(topId, channel);
  if (counts[key] === count) return;
  counts[key] = count;
  listeners.forEach((listener) => listener({ ...counts }));
}

export const getTrainingInboxCount = (allCounts, topId, channel) => allCounts[keyFor(topId, channel)] ?? null;

export function useTrainingInboxCounts() {
  const [snapshot, setSnapshot] = useState(() => ({ ...counts }));
  useEffect(() => {
    listeners.add(setSnapshot);
    setSnapshot({ ...counts });
    return () => { listeners.delete(setSnapshot); };
  }, []);
  return snapshot;
}

// Test hook.
export function resetTrainingInboxCounts() {
  Object.keys(counts).forEach((key) => { delete counts[key]; });
}
